<!--
    描述：小图标的详情页
    时间：2021/9/7
    创建人：王帅
-->
<template>
  <div>
    <!-- 企业实名 -->
    <template v-if="curType === 'company'">
      <el-row class="mb20">
        <el-col :span="24" class="upload-box">
          <el-carousel
            :autoplay="false"
            :loop="false"
            class="w100"
            height="180px"
            trigger="click"
          >
            <el-carousel-item
              class="carousel-item-style"
              :class="{ justifyContent: baseInfo.sysTenant.creType == '1' }"
            >
              <div class="upload-item">
                <!-- assortment 1 营业执照 -->
                <img
                  :src="`${uploadUrl}${imgUrl.licenseUrl}`"
                  alt="企业Logo"
                  @click="openBig(imgUrl.licenseUrl)"
                />
                <div class="top-item-text yyzz">营业执照</div>
              </div>
              <div class="upload-item" v-if="baseInfo.sysTenant.creType == '1'">
                <!-- assortment 2 代理人身份证（国徽面） -->
                <img
                  :src="`${uploadUrl}${imgUrl.emblemUrl}`"
                  alt="企业Logo"
                  @click="openBig(imgUrl.emblemUrl)"
                />
                <div class="top-item-text yyzz">代理人身份证（国徽面）</div>
              </div>
              <div class="upload-item" v-if="baseInfo.sysTenant.creType == '1'">
                <!-- assortment 3 代理人身份证（人像面） -->

                <img
                  :src="`${uploadUrl}${imgUrl.faceUrl}`"
                  alt="企业Logo"
                  @click="openBig(imgUrl.faceUrl)"
                />
                <div class="top-item-text yyzz">代理人身份证（人像面）</div>
              </div>
              <div class="upload-item" v-if="baseInfo.sysTenant.creType == '1'">
                <!-- assortment 4 企业委托书（盖章） -->
                <img
                  :src="`${uploadUrl}${imgUrl.entrustUrl}`"
                  alt="企业Logo"
                  @click="openBig(imgUrl.faceUrl)"
                />
                <div class="top-item-text yyzz">企业委托书（盖章）</div>
              </div>
              <div
                class="upload-item ml20"
                v-if="baseInfo.sysTenant.creType == '0'"
              >
                <!-- assortment 5 企业logo -->
                <img
                  :src="`${uploadUrl}${imgUrl.logoUrl}`"
                  alt="企业Logo"
                  @click="openBig(imgUrl.logoUrl)"
                />
                <div class="logo-style top-item-text">企业LOGO</div>
              </div>
            </el-carousel-item>
            <el-carousel-item v-if="baseInfo.sysTenant.creType == '1'">
              <div class="upload-item">
                <!-- assortment 5 企业logo -->
                <img
                  :src="`${uploadUrl}${imgUrl.logoUrl}`"
                  alt="企业Logo"
                  @click="openBig(imgUrl.logoUrl)"
                />
                <div class="logo-style top-item-text">企业LOGO</div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </el-col>
      </el-row>
      <el-row class="mt20 border-bottom">
        <el-form>
          <el-col :span="24">
            <el-form-item label="单位类型：" required>
              {{ baseInfo.sysTenant.flatTypeName }}
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="公司名称：" required>
              {{ baseInfo.sysTenant.sname }}
            </el-form-item>
          </el-col>
          <el-col :span="12" :offset="1">
            <el-form-item label="统一社会信用代码：" required>
              {{ baseInfo.sysTenant.creditCode }}
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="法人代表姓名：" required>
              {{ baseInfo.sysTenant.legal }}
            </el-form-item>
          </el-col>
          <el-col :span="12" :offset="1">
            <el-form-item label="法人代表手机号：" required>
              {{ baseInfo.sysTenant.legalPhone }}
            </el-form-item>
          </el-col>
          <el-col :span="11" v-if="baseInfo.sysTenant.creTypee == '0'">
            <el-form-item label="法人代表证件类型：" required>
              身份证
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="baseInfo.sysTenant.creType == '0'">
            <el-form-item label="法人代表证件号：" required>
              {{ baseInfo.sysTenant.legalNo }}
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="baseInfo.sysTenant.creType == '1'">
            <el-form-item label="代理人姓名：" required>
              {{ baseInfo.sysTenant.agent }}
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="baseInfo.sysTenant.creType == '1'">
            <el-form-item label="代理人手机号：" required>
              {{ baseInfo.sysTenant.agentPhone }}
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="baseInfo.sysTenant.creType == '1'">
            <el-form-item label="代理人证件类型：" required
              >身份证</el-form-item
            >
          </el-col>
          <el-col :span="12" v-if="baseInfo.sysTenant.creType == '1'">
            <el-form-item label="代理人证件号：" required>
              {{ baseInfo.sysTenant.agentNo }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="公司简称：" required>
              {{ baseInfo.sysTenant.shortName }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="注册地址：" required>
              {{ baseInfo.sysTenant.registAdd }}
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
    </template>

    <!-- 税务开票详情 -->
    <template v-if="curType === 'invoice'">
      <div class="invoice-layout">
        <el-row class="main-title">
          <svg-icon
            icon-class="apply-invoice"
            class="invoice-icon blue-invoice"
          ></svg-icon>
          <span class="ml15">已成功办理电子发票！</span>
        </el-row>
        <h3 class="text-title">税控盘信息</h3>
        <el-row class="text-row">
          <el-col :span="8" class="left">
            <svg-icon class="icons" icon-class="invoice-name"></svg-icon>
            纳税人名称
          </el-col>
          <el-col :span="16" class="right fr">{{ invoiceForm.sname }} </el-col>
        </el-row>
        <el-row class="text-row">
          <el-col :span="8" class="left">
            <svg-icon class="icons" icon-class="invoice-no"></svg-icon>
            纳税人识别号
          </el-col>
          <el-col :span="16" class="right fr">
            {{ invoiceForm.identifyNo }}
          </el-col>
        </el-row>
        <el-row class="text-row">
          <el-col :span="8" class="left">
            <svg-icon class="icons" icon-class="invoice-adress"></svg-icon>
            地址
          </el-col>
          <el-col :span="16" class="right fr"
            >{{ invoiceForm.address }}
          </el-col>
        </el-row>
        <el-row class="text-row">
          <el-col :span="8" class="left">
            <svg-icon class="icons" icon-class="invoice-phone"></svg-icon>
            电话
          </el-col>
          <el-col :span="16" class="right fr">{{ invoiceForm.phone }} </el-col>
        </el-row>
        <el-row class="text-row">
          <el-col :span="8" class="left">
            <svg-icon class="icons" icon-class="invoice-bank"></svg-icon>
            开户行
          </el-col>
          <el-col :span="16" class="right fr">{{ invoiceForm.bank }} </el-col>
        </el-row>
        <el-row class="text-row">
          <el-col :span="8" class="left">
            <svg-icon class="icons" icon-class="invoice-bankNo"></svg-icon>
            银行账号
          </el-col>
          <el-col :span="16" class="right fr"
            >{{ invoiceForm.account }}
          </el-col>
        </el-row>
        <el-row class="text-row">
          <el-col :span="8" class="left">
            <svg-icon class="icons" icon-class="invoice-num"></svg-icon>
            税控设备编号
          </el-col>
          <el-col :span="16" class="right fr">
            {{ invoiceForm.deviceNo }}
          </el-col>
        </el-row>
        <el-row class="text-row">
          <el-col :span="8" class="left">
            <svg-icon class="icons" icon-class="invoice-tag"></svg-icon>
            开票终端标识
          </el-col>
          <el-col :span="16" class="right fr">{{ invoiceForm.tag }} </el-col>
        </el-row>
        <el-row class="text-row">
          <el-col :span="8" class="left">
            <svg-icon class="icons" icon-class="invoice-type"></svg-icon>
            纳税人类型
          </el-col>
          <el-col :span="16" class="right fr">
            {{ invoiceForm.type == 1 ? "小规模纳税人" : "一般纳税人" }}
          </el-col>
        </el-row>
        <el-row class="text-row">
          <el-col :span="8" class="left">
            <svg-icon class="icons" icon-class="invoice-rate"></svg-icon>
            税率
          </el-col>
          <el-col :span="16" class="right fr">
            {{ invoiceForm.taxFileSname }}
          </el-col>
        </el-row>
      </div>
    </template>

    <!-- CA 详情 -->
    <template v-if="curType === 'CA'">
      <div class="ca-layout">
        <div v-if="caData.length > 0" class="mb10 mt20 text-center head">
          <span class="flex">
            <svg-icon icon-class="CA-rz" class="success-icon purple"></svg-icon>
            <span class="fontWeightBold ml10">
              已成功申请企业CA数字证书！
            </span>
          </span>

          <div class="isPass">
            <p v-if="isPass != ''">证书有效剩余天数：{{ isPass }} 天</p>
            <p v-else>证书已过期</p>
          </div>
        </div>
        <div v-else class="mb10 mt20 text-center">
          <svg-icon icon-class="CA-rz" class="success-icon purple"></svg-icon>
          <p class="fontWeightBold">已成功申请企业CA数字证书！</p>
        </div>
        <div class="pdl10 pdr10">
          <el-tabs v-model="activeCAName" @tab-click="switchTab">
            <el-tab-pane
              v-for="(item, index) in caData"
              :key="'certificate' + index"
              :label="'#' + (index + 1) + ' 证书'"
              :name="index + ''"
            >
              <el-row class="mt20">
                <el-col :span="8" class="left">
                  <svg-icon class="icons" icon-class="ca-owner"></svg-icon>
                  证书所有者
                </el-col>
                <el-col :span="16" class="right">{{ item.owner }} </el-col>
              </el-row>
              <el-row class="mt20">
                <el-col :span="8" class="left">
                  <svg-icon class="icons" icon-class="ca-cardNo"></svg-icon>
                  证件号
                </el-col>
                <el-col :span="16" class="right">{{ item.idNo }} </el-col>
              </el-row>
              <el-row class="mt20">
                <el-col :span="8" class="left">
                  <svg-icon class="icons" icon-class="ca-serial"></svg-icon>
                  证书序列号
                </el-col>
                <el-col :span="16" class="right">{{ item.cerSerial }} </el-col>
              </el-row>
              <el-row class="mt20">
                <el-col :span="8" class="left">
                  <svg-icon class="icons" icon-class="ca-time"></svg-icon>
                  证书有效期
                </el-col>
                <el-col :span="16" class="right">{{ item.endDate }} 止 </el-col>
              </el-row>
              <el-row class="mt20">
                <el-col :span="8" class="left">
                  <svg-icon class="icons" icon-class="ca-jz"></svg-icon>
                  介质类型 (key 华申3.0)
                </el-col>
                <el-col :span="16" class="right">{{ item.medSerial }} </el-col>
              </el-row>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </template>

    <!-- 企业账户 -->
    <template v-if="curType === 'account'">
      <PublicAccount
        ref="publicDialog"
        :accountList="accountList"
        :fileObj="fileObj"
      ></PublicAccount>
    </template>

    <!-- AZC -->
    <template v-if="curType === 'azc'">
      <div class="azc-layout">
        <el-row>
          <el-col :span="24">
            <span class="label">申请的企业：</span>
            {{ companyName }}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="flex">
            <span class="label">主体身份类型：</span>
            <el-checkbox-group v-model="azcForm.mainTypeArr" class="flex">
              <el-checkbox
                v-for="(item, index) in qyztlx"
                :label="item.value"
                :key="index"
                class="mr20"
                disabled
                >{{ item.sname }}
              </el-checkbox>
            </el-checkbox-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <span class="label">业务要求：</span>
            <template v-if="accountState === 1 || accountState === 2">
              <i
                class="text-icon"
                :class="
                  accountState === 1
                    ? ['success-icon', 'el-icon-success']
                    : ['warning-icon', 'el-icon-warning']
                "
              ></i>
              设置企业资金账户
            </template>
            <template v-else-if="accountPay === 1 || accountPay === 2">
              <i
                class="text-icon"
                :class="
                  accountPay === 1
                    ? ['success-icon', 'el-icon-success']
                    : ['warning-icon', 'el-icon-warning']
                "
              ></i>
              设置企业支付功能
            </template>
            <template v-else> 无 </template>
          </el-col>
        </el-row>
      </div>
    </template>
  </div>
</template>

<script>
import qyReal from "../../audit-affairs-new/components/qy-dialog";
import PublicAccount from "./public-account";
import { mapState } from "vuex";

export default {
  name: "show-info",
  components: {
    qyReal,
    PublicAccount,
  },
  props: {
    // 类型
    curType: {
      type: String,
      default: "",
    },
    // 统一社会信用代码
    creditCode: {
      type: String,
      default: "",
    },
    // CA
    caData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    // AZC recordId
    recordId: {
      type: Array,
      default: () => {
        return [];
      },
    },
    // AZC 企业名称
    companyName: {
      type: String,
      default: "",
    },
    // 账户步骤
    accountList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    // 影像件对象
    fileObj: {
      type: Object,
      default: () => {
        return {};
      },
    },
    //基本信息
    baseInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      invoiceForm: {},
      activeCAName: "",
      isPass: "", //是否过期
      azcForm: {},
      accountState: 0,
      accountPay: 0,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    // 根据不同类型加载不同接口
    getData() {
      switch (this.curType) {
        // CA
        case "CA":
          this.isPass = this.caData[0].effectiveTime;
          break;
        // 税务开票
        case "invoice":
          this.getInvoice();
          break;
        // 安招采
        case "azc":
          this.getAzc();
          break;
        // 企业账户
        case "account":
          // setTimeout(() => {
          //     this.$refs.publicDialog.applyDialog.visible = true
          //     this.$refs.publicDialog.applyDialog.title = '设置企业资金账户'
          //     this.$refs.publicDialog.applyDialog.mode = 'account'
          // }, 500)
          break;
      }
    },

    // 切换ca证书
    switchTab(data) {
      this.isPass = this.caData[data.index].effectiveTime;
    },

    // 获取税务开票数据
    getInvoice() {
          this.invoiceForm = this.baseInfo.invoiceObject;

    },

    // 获取安招采主体身份
    getAzc() {
      this.azcForm.mainType = this.baseInfo.azcObject.mainType;
      this.$set(
        this.azcForm,
        "mainTypeArr",
        this.baseInfo.azcObject.mainType.split(",")
      );
      if (this.azcForm.mainType !== "") {
        if(this.baseInfo.azcObject.accountFlag){
            this.accountState = res.data.accountFlag ? 1 : 2;
        }
        if(this.baseInfo.azcObject.payFlag){
            this.accountPay = res.data.payFlag ? 1 : 2;
        }
      }
    },

    // 获取企业身份
    dealWith(data) {
      let name = "";
      switch (data) {
        case 0:
          name = "企业成员";
          break;
        case 1:
          name = "企业主";
          break;
        case 2:
          name = "企业管理员";
          break;
      }
      return name;
    },
    // 打开大图
    openBig(url) {
      if (url && url !== "") {
        this.imgVisible = true;
        this.currentImg = url;
      }
    },
  },
  computed: {
    ...mapState("dict", {
      qyztlx: (state) => state.qyztlx,
    }),
    // 上传接口地址
    uploadUrl() {
      return this.$uploadUrl;
    },
    // 企业图片url
    imgUrl() {
      return this.baseInfo.files;
    },
  },
};
</script>

<style scoped lang="less">
.ca-layout {
  .head {
    font-size: 20px;
    line-height: 80px;
    display: flex;
    align-items: center;
    margin: 10px 0 20px;
    justify-content: space-between;

    svg {
      font-size: 80px;
      color: #2671cc;
    }
  }

  .fontWeightBold {
    font-weight: bold;
  }

  .left {
    color: #999999;
    font-size: 12px;
    display: flex;
    align-items: center;
  }

  .right {
    color: #202020;
    font-weight: 600;
    text-align: right;
  }

  .icons {
    font-size: 20px;
    margin-right: 10px;
  }
}

.invoice-layout {
  .main-title {
    font-size: 20px;
    line-height: 80px;
    display: flex;
    align-items: center;
    margin: 10px 0 20px;
    justify-content: center;

    svg {
      font-size: 80px;
      color: #2671cc;
    }
  }

  .text-title {
    line-height: 40px;
    font-size: 20px;
  }

  .text-row {
    line-height: 36px;
  }
}

.azc-layout {
  color: #000;
  line-height: 30px;
  font-size: 14px;

  .label {
    color: #666;
    flex-shrink: 0;
  }

  .success-icon {
    color: #72aa2c;
  }

  .warning-icon {
    color: #e6a23c;
  }
}
.upload-item {
  width: 220px;
  height: 150px;
  /deep/ .upload-text {
    vertical-align: middle !important;
  }
  img {
    width: 220px;
    height: 150px;
    display: block;
    background: #fbfdff;
    border: 1px solid #c2dcfb;
    border-radius: 6px;
  }
}
.top-item-text {
  text-align: center;
}
.carousel-item-style {
  display: flex;
}
.justifyContent {
  justify-content: space-between;
}
</style>
